module.exports = __webpack_public_path__ + "img/P24-en.c9c770a2.png";